import { Icon } from '@a-ui/react';
import { useEffect } from 'react';
import { useSelector, useDispatch  } from 'react-redux'
import { closeModal } from '../../store/slices/modalReducer'
import CompleteTask from './ModalContent/CompleteTask'
import CancelTask from './ModalContent/CancelTask'
import Filters from './ModalContent/Filters'
import Planning from './ModalContent/Planning'
import CreateTask from './ModalContent/CreateTask'
import DescriptionTask from './ModalContent/DescriptionTask'
import FormTask from './ModalContent/FormTask'
import StartTaskBulk from './ModalContent/StartTaskBulk'

import '../../styles/modal.scss';

const Modal = (props) => {

  const dispatch = useDispatch();
  const { open, modalContent } = useSelector(state => state.modal);
  const titles = {
    CompleteTask: 'Taak voltooien',
    CancelTask: 'Taak afbreken',
    CreateTask: 'Nieuwe taak aanmaken',
    Filters: 'Filters',
    Planning: 'Planning',
    Description: 'Beschrijving',
    StartTaskBulk: 'Tijdregistratie starten voor meerdere gebruikers',
  }
  const title =  titles[modalContent];
  const downHandler = ({ key  }) => {
    if (key === "Escape") {
      dispatch(closeModal())
    }
  };
  useEffect(() => {
    if(open) window.addEventListener("keydown", downHandler);
    return () => window.removeEventListener("keydown", downHandler);
  });
  if(!open) return false;
  return <div className="m-overlay is-active" onClick={(e) => {
    e.stopPropagation();
    if(e.target.classList.contains("m-overlay")) {
      dispatch(closeModal())
    }
  }}>
    <div className="m-modal m-modal--l">
      <div className="u-margin">
      <div className="row">
        <div className="col-xs-8 u-margin-bottom-s">
          <h3 className="h2">{title}</h3>
        </div>
        <div className="col-xs-4 u-margin-bottom-s u-text-right ">
          <Icon name="ai-remove" className="close pointer" onClick={() => {dispatch(closeModal())}}/>
        </div>
      </div>
        { modalContent === "CompleteTask" && <CompleteTask/>}
        { modalContent === "CancelTask" && <CancelTask/>}
        { modalContent === "Filters" && <Filters/>}
        { modalContent === "Planning" && <Planning/>}
        { modalContent === "CreateTask" && <CreateTask/>}
        { modalContent === "Description" && <DescriptionTask/>}
        { modalContent === "Form" && <FormTask/>}
        { modalContent === "StartTaskBulk" && <StartTaskBulk/>}
      </div>
    </div>
  </div>

}

export default Modal;
